// third party
import * as yup from 'yup';

// project imports
import { validationSchema as phoneNumberValidationSchema } from '../phone-number';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        lastName: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-lastname-max', values: { maxValue: 255 } }))
            .nullable(),
        department: yup
            .object()
            .shape({})
            .nullable()
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-department-required' })),
        user: yup.object().shape({}).nullable(),
        email: yup
            .string()
            .email(intl.formatMessage({ id: 'ui-comp-formvalidation-email-invalid' }))
            .lowercase(),
        phoneNumbers: yup.array().of(phoneNumberValidationSchema(intl)).nullable()
    });

export default validationSchema;
